/** @jsx h */
import { Component, h, JSX, ComponentChild } from 'preact';
import style from '../index.css';
import { RootStore } from '../../../../../../common/js/stores/root.store';

interface CustomStyles {
  topControls: Record<string, string | number>;
  bottomControls: Record<string, string | number>;
}

interface DefaultFullscreenControlsProps {
  customStyles: CustomStyles;
  showClose: boolean;
  showExpand: boolean;
  showInformation: boolean;
  closeItem: ComponentChild;
  expandItem: ComponentChild;
  informationItem: ComponentChild;
  optOutItem: ComponentChild;
  soundItem: ComponentChild;
}

export class DefaultFullscreenControls extends Component<
  DefaultFullscreenControlsProps
> {
  render(): JSX.Element {
    const {
      customStyles,
      showClose,
      showExpand,
      showInformation,
      closeItem,
      expandItem,
      informationItem,
      optOutItem,
      soundItem
    } = this.props;

    const showOptOut = RootStore.getInstance().controlsStore.shouldDisplayOptOut();

    return (
      <div className={style.fullscreenControls}>
        <div
          className={style.fullscreenControlsRow}
          style={customStyles.topControls}
        >
          {soundItem}
          {showInformation ? informationItem : ''}
          {showExpand ? expandItem : ''}
        </div>
        <div
          className={style.fullscreenControlsRow}
          style={customStyles.bottomControls}
        >
          {showOptOut ? optOutItem : <div />}
          {showClose ? closeItem : ''}
        </div>
      </div>
    );
  }
}
